import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Retailer, RetailerFilterCriteria} from "./retailers.model";
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RetailersService {

  baseUrl: string;

  constructor(public http: HttpClient) {
    this.baseUrl = environment.apiRetailersHost + `/console/offering/district/pipeline/retailers`;
  }

  getAll(criteria?: RetailerFilterCriteria): Observable<Retailer[]> {
    let requestParams = new HttpParams();
    if (criteria) {
      Object.keys(criteria).forEach((key: string) => {
        const value = (criteria as Record<string, any>)[key];
        if (value !== null && value !== undefined) {
          requestParams = requestParams.append(key, value);
        }
      })
    }

    return this.http.get<Retailer[]>(environment.apiRetailersHost + `/console/offering/district/pipeline/retailers`, {params: requestParams});
  }

}
